import { HStack, PlatformEnum } from "../../../shared/utils";
import ProductMainCard from "./sampleCard";

export function ProductCards(data: any) {
  const captableCompanies: any[] = [];
  const esopCompanies: any[] = [];
  data &&
    data?.data?.forEach((platform: any) => {
      if (platform.platform === "captable") {
        captableCompanies.push(platform.data.companies);
      } else if (platform.platform === "esop") {
        esopCompanies.push(platform.data.companies);
      }
    });

  function getCurrentPlatformData(platform: string) {
    const currentPlatform = Array.isArray(data?.data)
      ? data.data.find(
          (obj: any) => obj.platform?.toLowerCase() === platform.toLowerCase()
        )
      : undefined;
    return currentPlatform?.data;
  }

  return (
    <HStack
      className="flex flex-wrap overflow-scroll md:flex-nowrap justify-center md:justify-between gap-6 md:mb-0 mt-6 py-2 z-10"
      style={{
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      <ProductMainCard
        title="CAPTABLE"
        description="Equity management platform for companies. where you can watch and manage your company states."
        imageUrl="/media/Captable_Icon.svg"
        bgColor="#E6EFFF"
        titleClassName="pr-16"
        titleBgColor="#4682E3"
        arrowColor="#FFFFFF"
        redirectURL={process.env.REACT_APP_CAPTABLE_URL || ""}
        buttonType="dropdown"
        access={
          getCurrentPlatformData("captable") &&
          getCurrentPlatformData("captable")?.access
        }
        companies={getCurrentPlatformData("captable")?.companies || []}
        platform={PlatformEnum.captable}
      />
      <ProductMainCard
        title="ESOP"
        description="Streamlined platform designed for efficiently managing Employee Stock Ownership Plans (ESOPs) with ease and accuracy."
        imageUrl="/media/Esop_Icon.svg"
        bgColor="#FAF9F3"
        titleBgColor="#C1A810"
        titleClassName="pr-24"
        arrowColor="#FFFFFF"
        redirectURL={process.env.REACT_APP_ESOP_URL || ""}
        buttonType="dropdown"
        access={
          getCurrentPlatformData("esop") &&
          getCurrentPlatformData("esop")?.access
        }
        companies={getCurrentPlatformData("esop")?.companies || []}
        platform={PlatformEnum.esop}
      />
      <ProductMainCard
        title="Portfolio"
        description=" A secure and intuitive platform for managing investments and monitoring portfolio performance."
        imageUrl="/media/Portfolio_Icon.svg"
        bgColor="#E9FBF3"
        titleClassName="pr-12"
        titleBgColor="#3BC482"
        arrowColor="#FFFFFF"
        redirectURL={process.env.REACT_APP_INVESTOR_URL || ""}
        buttonType="button"
        access={
          getCurrentPlatformData("investor") &&
          getCurrentPlatformData("investor")?.access
        }
        platform={PlatformEnum.investor}
      />
      <ProductMainCard
        title="Task Manager"
        description="A secure platform that enables efficient organization, tracking, and prioritization of tasks to enhance productivity."
        imageUrl="/media/Task_manager_Icon.svg"
        bgColor="#FEF2E7"
        titleClassName="pr-8"
        titleBgColor="#E95936"
        arrowColor="#FFFFFF"
        redirectURL={process.env.REACT_APP_TASKMANAGER_URL || ""}
        buttonType="button"
        access={
          getCurrentPlatformData("taskmanager") &&
          getCurrentPlatformData("taskmanager")?.access
        }
        platform={PlatformEnum.taskManager}
      />
    </HStack>
  );
}
